import React from "react";
import Select from "react-select";

const SelectDropdown = ({
  data = [],
  value,
  onChange = () => {},
  placeholder = "",
  isDisabled = false,
  errors,
  isSearchable=false,
  isLoading=false
}) => {
  return (
    <>
      <div>
        <Select
          isClearable={true}
          defaultValue={value}
          onChange={onChange}
          options={data}
          placeholder={placeholder}
          isDisabled={isDisabled}
          isSearchable={isSearchable}
          isLoading={isLoading}
        />
      </div>
      <div className="d-flex">
        <div style={{ color: "red" }}>{errors}</div>
      </div>
    </>
  );
};

export default React.memo(SelectDropdown);
